import { DocumentsMap } from './types';

export const isSelectionValid = (map: DocumentsMap) => [...map.values()].every(Boolean);

export const isCopyTitle = (title: string) => {
  // eslint-disable-next-line security/detect-unsafe-regex
  const regex = /\(\s*copy(?:\s+\d+)?\s*\)$/i;
  return regex.test(title);
};

export const makeCopyTitle = (title: string, index = 0) => {
  const suffix = index > 0 ? ` ${index}` : '';
  return `${title} (copy${suffix})`;
};
